import React from 'react';
import Slider from 'react-slick';
import { Image } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './homeBanner.css'

const HomeSlider = ({ homeBannerImages }) => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 2500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        fade: true,
        autoplaySpeed:6000,
        vertical: true,
        arrows: false,
        responsive:[
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 0,
                    slidesToScroll: 0,
                    initialSlide: 0,
                    swipe: false,
                    swipeToSlide: false,
                    touchMove: false,
                    centerMode: false,
                    autoplay: false,
                }
            }
        ]
        
    };

    let path = '/images/home/';
    return (
        <div className='animiSilder'>
            <Slider {...settings}>
                {
                    homeBannerImages && homeBannerImages.length > 0 && homeBannerImages.map((item, key) => {
                        return (
                            <div key={item.id} className={s.sliderImageContainer}>
                                <Image src={`${path}${item.name}`} className={cx(s.sliderImage,homeBannerImages.length == 1 ? 'singleAimation':"animiSlide")} ></Image>
                            </div>
                        )
                    })
                }
            </Slider>
        </div>
    )
}


export default injectIntl(withStyles(s)(HomeSlider));